import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef  } from '@angular/core';
import { first } from 'rxjs/operators'
import {MatChipInputEvent} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from "@ngx-translate/core";
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { PreguntasService } from "../../../preguntas.service";
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";

declare var $: any;
import * as RecordRTC from 'recordrtc';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('stepsBuscar') stepsBuscar: MatStepper;
  @ViewChild('stepsVersion') stepsVersion: MatStepper;
  columnasResultado: string[] = ['pregunta'];

  listasPreguntas: any[] = ['lista0'];

  preguntaCatalogo: any;
  indicePregunta = 0;
  versionPregunta = 0;
  indiceTraduccion = 0;
  versionSeleccionada = 0;
  arrayPreguntas: any[] = [];

  catalogoMaximos = [
    { valor: 999999, titulo: 'Sin límite' },
  ]

  idiomaNativo: string;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  tipoBusqueda: boolean;
  busqueda: string;
  searchTags: any[] = [];
  buscando: boolean;
  arrBusqueda: any[] = [];
  resultados: MatTableDataSource<any>;
  idsUniqueBusqueda: any[] = [];

  indicePasosAudio: number;
  tipoAudioSel: number;
  textoAudio: string = '';

  //Lets declare Record OBJ
  record;
  //Will use this flag for toggeling recording
  recording = false;
  //URL of Blob
  url;
  //Cadena base 64 del audio
  cadenaB64: string;
  error;
  generandoAudio:boolean;
  infoVoces: any;

  //seccion especial
  tipoSeccion: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalComponent>,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private preguntasService: PreguntasService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private domSanitizer: DomSanitizer,
    private surveyProductService: SurveyProductService
  ) {
    lang_cerv3.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    //llena catalogo máximos
    for (let i = 1; i <= 10; i++) {
      this.catalogoMaximos.push({ valor: i, titulo: i.toString() });
    }
  }

  async ngOnInit() {
    console.log("datosRecibidos:",this.datos);
    this.cdr.detectChanges();
    let indiceIdiomaNativo = this.datos.idiomas.findIndex(item => item.tipoIdioma == "1");
    this.idiomaNativo = this.datos.idiomas[indiceIdiomaNativo].nombreIdioma;
    if(this.datos.opcion == "preguntaCat"){
      this.filtraPreguntasElegidas();
    }
    if(this.datos.opcion == 'nuevoAudio'){
      if(this.datos.practica4All){
        this.textoAudio = this.datos.datosPregunta.question + " " + this.datos.datosPregunta.description4all;
      } else{
        this.textoAudio = this.datos.datosPregunta.question;
      }
      this.recuperaConfigVoces();
      if (this.datos.recuperarPregCat == true && this.datos.datosPregSP.idUnique < 99999) {
        let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(this.datos.datosPregSP.idUnique).toPromise();
        this.datos.pregCat = datosPreguntaCat;
      }
    }
    if(this.datos.opcion == 'seccionEspecial'){
      this.tipoSeccion = this.datos.datosSeccion.typeCustom == 2 ? true : false;
      const campoClave = document.querySelector('[name="claveSeccion"]');
      campoClave.addEventListener('keypress', ( event:any ) => {
         var key = event.keyCode;
          if (key === 32) {
            event.preventDefault();
          }
      });
    }
    if(this.datos.tipoSeccion == 6){  // si es la seccion 6(4ALL) se quita la primera opcion de numero de preguntas (sin limite)
      const elementoRemovido = this.catalogoMaximos.shift();
    }
  }

  filtraPreguntasElegidas(){
    this.datos.catalogo.forEach(pregunta => {
      pregunta.ocupada = false;
      if(this.datos.idsUniqueOcupadas.includes(pregunta.idUnique)){
        pregunta.ocupada = true;
      }
    });
  }

  limpiaBusqueda(){
    switch (this.tipoBusqueda) {
      case true:  //por tags
        this.busqueda = null;
        this.resultados = new MatTableDataSource<any>([]);
        setTimeout(() => this.resultados.paginator = this.paginator);
      break;
      case false:  //por texto
        this.searchTags = [];
        this.resultados = new MatTableDataSource<any>([]);
        setTimeout(() => this.resultados.paginator = this.paginator);
      break;
    }
  }

  buscaPregunta(modo:number){
    let datos: any = {};
    if(modo == 1){  //modo texto
      if(this.busqueda.substr(0,1) == "." || this.busqueda == ""){
        this.busqueda = null;
      }
    }
    else if(modo == 2){ //modo tags
      this.busqueda = null;
      datos.tags = this.searchTags;
    }
    this.buscando = true;
    this.preguntasService.buscaPreguntaCatMaster(this.busqueda, modo, datos).subscribe((respuesta:any) => {
      console.log("buscaPregutaCAt:",respuesta);
      if(respuesta.success){
        this.arrBusqueda = [];
        respuesta.questions.forEach(pregunta => {
          if(this.datos.tipoPreguntaSeccion.includes(pregunta.answerType)){
            if(!this.datos.idsUniqueOcupadas.includes(pregunta.idUnique) && !this.idsUniqueBusqueda.includes(pregunta.idUnique) && this.arrayPreguntas.findIndex(item => item.preguntaCat.idUnique == pregunta.idUnique) == -1){
              pregunta.ocupada = false;
              this.arrBusqueda.push(pregunta);
            }
          }
        });
        this.resultados = new MatTableDataSource<any>(this.arrBusqueda);
        this.buscando = false;
        setTimeout(() => this.resultados.paginator = this.paginator);
        // console.log("this.resultados:",this.resultados);
      }
    });
  }

  preguntaBusqueda(pregCat:any){
    console.log("pregCat:",pregCat);
    if(pregCat.textVersions.length == 1){
      this.arrayPreguntas.push({
        preguntaCat: pregCat,
        indiceVersion: 1
      });
      let indiceResultado = this.arrBusqueda.findIndex(item => item.idUnique == pregCat.idUnique);
      this.idsUniqueBusqueda.push(pregCat.idUnique);
      this.arrBusqueda.splice(indiceResultado,1);
      this.resultados = new MatTableDataSource<any>(this.arrBusqueda);
      this.resultados.paginator = this.paginator;
      let indicePregEnCatalogo = this.datos.catalogo.findIndex(item => item.idUnique == pregCat.idUnique);
      this.datos.catalogo[indicePregEnCatalogo].ocupada = true;
      this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_MOD_AGRE_PREG'), "OK");
    }
    else{
      this.eligePreguntaCat(0, pregCat); //
      this.stepsBuscar.selectedIndex = 1;
    }
  }
  agregaPreguntaCatBusqueda(){
    this.preguntaCatalogo.ocupada = true;
    this.arrayPreguntas.push({
      preguntaCat: this.preguntaCatalogo,
      indiceVersion: this.versionSeleccionada
    });
    this.idsUniqueBusqueda.push(this.preguntaCatalogo.idUnique);
    this.arrBusqueda.splice(this.arrBusqueda.findIndex(item => item.idUnique == this.preguntaCatalogo.idUnique),1);
    this.resultados = new MatTableDataSource<any>(this.arrBusqueda);
    this.resultados.paginator = this.paginator;
    let indicePregEnCatalogo = this.datos.catalogo.findIndex(item => item.idUnique == this.preguntaCatalogo.idUnique);
    this.datos.catalogo[indicePregEnCatalogo].ocupada = true;
    this.stepsBuscar.selectedIndex = 0;
    this.versionPregunta = null;
    this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_MOD_AGRE_PREG'), "OK");
  }
  cambiaVersionPregSel(paso:number, indicePregunta?:number){
    switch (paso) {
      case 1:
        this.preguntaCatalogo = this.arrayPreguntas[indicePregunta].preguntaCat;
        this.indicePregunta = indicePregunta;
        this.stepsVersion.selectedIndex = 1;
      break;
      case 2:
        this.arrayPreguntas[this.indicePregunta].indiceVersion = this.versionSeleccionada;
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_MOD__MODIF_VERSI_PREG'), "OK");
        this.stepsVersion.selectedIndex = 0;
      break;
    }
  }

  eligePreguntaCat(indicePregunta:number, datosPregunta?:any){
    if(!datosPregunta){
      this.preguntaCatalogo = this.datos.catalogo[indicePregunta];
      this.indicePregunta = indicePregunta;
    }
    else{
      this.preguntaCatalogo = datosPregunta;
    }
    if(this.preguntaCatalogo.textVersions.length == 1){
      this.versionPregunta = 0;
      this.versionSeleccionada = 1;
      this.indiceTraduccion = this.preguntaCatalogo.textVersions[this.versionPregunta].questionLanguage.findIndex(item => item.lang == this. idiomaNativo);
    }
    else this.versionPregunta = null;
  }
  eligeVersionPreguntaCat(indices:any){
    this.versionSeleccionada = indices.versionSeleccionada;
    this.versionPregunta = indices.indiceVersion;
    this.indiceTraduccion = indices.indiceTraduccion;
  }
  agregaPreguntaCat(){
    // this.arrayPreguntas.push(this.datos.catalogo[this.indicePregunta].versiones[this.versionPregunta]);
    this.preguntaCatalogo.ocupada = true;
    this.arrayPreguntas.push({
      preguntaCat: this.preguntaCatalogo,
      indiceVersion: this.versionSeleccionada
    });
    this.datos.catalogo[this.indicePregunta] = this.preguntaCatalogo;
    this.versionPregunta = null;
    this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_MOD_AGRE_PREG'), "");
  }

  borraPreguntaLista(idUnique:number){
    if(this.idsUniqueBusqueda.includes(idUnique)){
      this.idsUniqueBusqueda.splice(this.idsUniqueBusqueda.indexOf(idUnique),1);
    }
    let indicePregCat = this.arrayPreguntas.findIndex(item => item.preguntaCat.idUnique == idUnique);
    this.arrayPreguntas.splice(indicePregCat,1);
    let indicePregEnCatalogo = this.datos.catalogo.findIndex(item => item.idUnique == idUnique);
    this.datos.catalogo[indicePregEnCatalogo].ocupada = false;
    this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG'), "");
    this.cdr.detectChanges();
  }

  reparaIdiomasFaltantes(datosPregunta:any){
    let preguntaReparada: boolean;
    //recorre respuestas si tiene :v
    if(datosPregunta.answers){
      datosPregunta.answers.forEach(respuesta => {
        respuesta.textVersions.forEach(versionResp => {
          if(this.datos.catalogoIdiomasSurvey.length != versionResp.answerLanguage.length){ //si la longitud de idiomas no coincide
            this.datos.catalogoIdiomasSurvey.forEach(idioma => {
              let indiceIdioma = versionResp.answerLanguage.findIndex(item => item.lang == idioma.abbr);
              if(indiceIdioma == -1){ //si el idioma no existe, se le agrega a la pregunta
                versionResp.answerLanguage.push({
                  tag: "",
                  vivo: 1,
                  idLanguage: parseInt(idioma.idLanguage),
                  lang: idioma.abbr
                });
                preguntaReparada = true;
              }
            });
          }
        });
      });
    }
    //recorre texto de la pregunta
    datosPregunta.textVersions.forEach(versionPregunta => {
      if(this.datos.catalogoIdiomasSurvey.length != versionPregunta.questionLanguage.length){ //si la longitud de idiomas no coincide
        this.datos.catalogoIdiomasSurvey.forEach(idioma => {
          let indiceIdioma = versionPregunta.questionLanguage.findIndex(item => item.lang == idioma.abbr);
          if(indiceIdioma == -1){ //si el idioma no existe, se le agrega a la pregunta
            versionPregunta.questionLanguage.push({
              question: "",
              vivo: 1,
              idLanguage: parseInt(idioma.idLanguage),
              lang: idioma.abbr,
              pendiente: true
            });
            preguntaReparada = true;
          }
        });
      }
    });
    return {
      datosPregunta,
      preguntaReparada
    };
  }

  dropPregunta(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  agregaTag(event: MatChipInputEvent, origen:number): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if(value.substr(0,1) == '#'){
        this.searchTags.push(value.trim());
      }
      else{
        this.openSnackBar("La palabra clave no comenzó con el caracter #", "OK");
      }
    }
    if (input) {
      input.value = '';
    }
    if(this.searchTags.length > 0){
      this.buscaPregunta(2);
    }
  }

  borraTag(tag: any, origen:number): void {
    let indice: number;
    indice = this.searchTags.indexOf(tag);
    if (indice != -1) {
      this.searchTags.splice(indice, 1);
    }
  }

  ///// FUNCIONES DE CARGA DE AUDIO

  recuperaConfigVoces(){
    this.surveyProductService.enviaDatosASurvProd({ recuperaConfigVoces: true });
    this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
      console.log("---------------------------DATOS RECIBIDOS MODAL :V ----------------------------");
      console.log(datos);
      this.infoVoces = datos.infoVoces;
    });
  }

  DEMO_generaAudioTTS(texto:string){
    this.url = undefined;
    this.preguntasService.generaAudioPregunta({texto, claveIdioma: this.datos.datosPregunta.lang, productoId: localStorage.getItem('productoID')}).subscribe((respuesta:any) => {
      console.log("generaAudioPregunta:",respuesta);
      if(respuesta.success){
        this.DEMO_convierteAudioBlob(respuesta.response.audioContent);
        this.generandoAudio = false;
      }
    });
  }

  DEMO_regresarPaso2(){
    Swal.fire({
      icon: 'question',
      title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.DESCARTAR'),
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
      confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        this.indicePasosAudio = 1;
        this.url = undefined;
        this.cadenaB64 = undefined;
      }
    });
  }

  cargaAudio(event:any, opcion:number){
    console.log(opcion,", event:",event);

    var file:any = opcion == 1 ? event[0] : event.target.files[0];
    console.log(file);
    if(file.type == 'audio/mpeg'){
      this.url = undefined;
      var reader = new FileReader();
      reader.readAsBinaryString(file);

      reader.onload = () => {
        // console.log("base64 del archivo:",btoa(reader.result.toString()));
        this.DEMO_convierteAudioBlob(btoa(reader.result.toString()));
      };
      reader.onerror = function() {
        console.log('there are some problems');
      };
    } else{
      this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.ARCHIVO_MAL'), "");
    }
  }

  DEMO_convierteAudioBlob(cadenaB64:string){
    this.cadenaB64 = cadenaB64;
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    const contentType = 'audio/mpeg';
    const b64Data = cadenaB64;

    const blob = b64toBlob(b64Data, contentType);
    this.url = URL.createObjectURL(blob);
    this.indicePasosAudio = 2;
  }

  cambioStep(event:any){
    // console.log("event:",event);
    this.indicePasosAudio = event.selectedIndex;
  }

  sanitize(url: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(url);
  }

  /**
  * Start recording.
  */
  initiateRecording() {
    this.recording = true;
    let mediaConstraints = {
      video: false,
      audio: true
    };
    navigator.mediaDevices.getUserMedia(mediaConstraints).then(this.successCallback.bind(this), this.errorCallback.bind(this));
  }
  /**
  * Will be called automatically.
  */
  successCallback(stream) {
    var options = {
      mimeType: "audio/wav",
      numberOfAudioChannels: 2,
      bufferSize: 16384
    };
    //Start Actuall Recording
    var StereoAudioRecorder = RecordRTC.StereoAudioRecorder;
    this.record = new StereoAudioRecorder(stream, options);
    this.record.record();
  }
  /**
  * Stop recording.
  */
  stopRecording() {
    this.recording = false;
    this.url = undefined;
    this.record.stop(this.processRecording.bind(this));
  }
  /**
  * processRecording Do what ever you want with blob
  * @param  {any} blob Blog
  */
  processRecording(blob) {
    this.url = URL.createObjectURL(blob);
    console.log("blob", blob);
    console.log("url", this.url);
    //CONVIERTE EL BLOB DEL AUDIO GRABADO A BASE64
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      this.cadenaB64 = reader.result.toString();
    }
  }
  /**
  * Process Error.
  */
  errorCallback(error) {
    this.error = 'Can not play audio in your browser';
  }

  ///TIPO SECCION

  cambiaStatusSecEsp(status:boolean){
    if(status == false){
      Swal.fire({
        icon: 'question',
        title: this.translateSrv.instant('CERTIFICARV3.MODAL_SEC_ESP.MODALES.CONFIRM_DISABLE'),
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
        confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR'),
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.value) {
          this.datos.datosSecciones.forEach(seccion => {
            if(seccion.typeCustom != 1){
              console.log("seccionCambiada:",seccion);
              seccion.typeCustom = 1;
              seccion.tagCustom = '';
            }
          });
          this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.MODAL_SEC_ESP.MODALES.DISABLE_OK'), "");
        } else{
          this.datos.configTemplate.secEspeciales = true;
        }
      });
    }
  }

  salir(opcion?:number) {
    let datos: any = {
      status:true
    };
    if(opcion != null){
      datos.indiceNuevo = opcion;
    }

    this.dialogRef.close(datos);
  }

  salirConfig(){
    this.dialogRef.close(this.datos.configTemplate);
  }

  async salirPregCat(){
    // this.arrayPreguntas.forEach(preguntaAgregada => {
    for(let preguntaAgregada of this.arrayPreguntas){
      /// HACER EL GETONE DEL CATALOGO MAESTRO
      let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(preguntaAgregada.preguntaCat.idUnique).toPromise();
      let datosCorregidos = this.reparaIdiomasFaltantes(datosPreguntaCat);
      preguntaAgregada.preguntaCat = datosCorregidos.datosPregunta;
      if(datosCorregidos.preguntaReparada){
        preguntaAgregada.actualizarPregunta = true;
      }
    }
    // });
    this.dialogRef.close({arrayPreguntas: this.arrayPreguntas});
  }

  salirNuevoAudio(){
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.GUARDANDO'),
      allowOutsideClick: false,
      showConfirmButton: false,
      imageUrl: localStorage.getItem('urlGifBroker'),
      imageWidth: 60
    });
    const datosTTS = {
      idUnique: '1',
      lang: this.datos.datosPregunta.lang,
      base64: this.cadenaB64
    };
    if(this.datos.pregCat != undefined){
      this.preguntasService.generaLinkMp3(datosTTS).subscribe((respuestaTTS:any) => {
        console.log("generaLinkMp3:",respuestaTTS);
        if(respuestaTTS.success){
          const refTypAdd = this.datos.datosPregSP.typeAdd; //estado de la pregunta
          const tiposValidos = [0,1]; //estados donde si se puede guardar audio al catalogo
          const tiposNoValidos = [4,5]; //estados donde no se debe guardar audio al catalogo
          if(this.datos.datosPregunta.audio == false &&  ( tiposValidos.includes(refTypAdd) || this.datos.audioTraduccion == true ) && !tiposNoValidos.includes(refTypAdd) ){ //si la pregunta no tiene audio y el typeadd es 0 o 1 y no es 4 o 5, se guarda el audio al catalogo
            console.log("sin audio y typeadd 0 o audio de traduccion, guardará audio a catalogo");

            const datosURL = {
              idUnique: this.datos.pregCat.idUnique,
              versionId: this.datos.datosPregSP.versionId,
              lang: this.datos.datosPregunta.lang,
              gender: this.infoVoces[this.datos.datosPregunta.lang].gender,
              languageCode: this.infoVoces[this.datos.datosPregunta.lang].languageCode,
              nameVoice: this.infoVoces[this.datos.datosPregunta.lang].nameVoice,
              url: respuestaTTS.newPath
            }
            console.log("datosURL:",datosURL);
            this.preguntasService.saveQuestionAudio(datosURL).subscribe((respuestaSave:any) => {
              console.log("saveQuestionAudio:",respuestaSave);
              if(respuestaSave.success){
                // this.datos.datosPregSP.typeAdd = 6;
                this.dialogRef.close({
                  base64: this.cadenaB64,
                  url: respuestaTTS.newPath
                });
                Swal.close();
              } else{
                Swal.fire({
                  icon: 'error',
                  title: 'Ocurrió un error al guardar la pista de audio, vuelva a intentarlo',
                  confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR')
                });
              }
            });
          } else{
            console.log("con audio o typeadd diferente a 0 o 1, no se guardara a catalogo, se actualizará typeadd a 6");

            Swal.close();
            if(this.datos.datosPregSP.typeAdd != 6){  //
              this.datos.datosPregSP.typeAdd = 6;
            }
            this.dialogRef.close({
              base64: this.cadenaB64,
              url: respuestaTTS.newPath
            });
          }
        }
      });
    } else{
      this.preguntasService.generaLinkMp3(datosTTS).subscribe((respuesta:any) => {
        console.log("generaLinkMp3:",respuesta);
        Swal.close();
        if(respuesta.success){
          this.dialogRef.close({
            base64: this.cadenaB64,
            url: respuesta.newPath
          });
        }
      });
    }
  }

  salirSeccionEsp(){
    if(this.datos.datosSeccion.typeCustom == 2){
      if(this.datos.datosSeccion.tagCustom == ''){
        Swal.fire({
          icon: 'error',
          title: this.translateSrv.instant('CERTIFICARV3.MODAL_SEC_ESP.MODALES.SIN_CLAVE'),
          confirmButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_OK')
        });
      } else{
        this.dialogRef.close(true);
      }
    } else{
      this.datos.datosSeccion.tagCustom = '';
      this.dialogRef.close(true);
    }
  }
}
